import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmark: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBookmark"><Path d="M6.5 2C5.11929 2 4 3.11929 4 4.5V20.4966C4 21.6839 5.31395 22.4005 6.31215 21.7577L11.1878 18.6177C11.6824 18.2992 12.3176 18.2992 12.8122 18.6177L17.6878 21.7577C18.6861 22.4005 20 21.6839 20 20.4966V4.5C20 3.11929 18.8807 2 17.5 2H6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookmark;
